var render = function render(){var _vm=this,_c=_vm._self._c;return _c('subsystem-iframe-shell',{attrs:{"external-path":"/device/lightingControl","frame-title":"照明"}})
}
var staticRenderFns = []

export { render, staticRenderFns }